import React, { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import * as ls from 'local-storage'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import { DataTableContainer, ResponsiveTableWrap } from '../../../CropRotation/CropRotation.styles'
import { API } from '../../../../providers/API'
import { Loading } from '../../../Loading/Loading'
import { CarbonEnrollmentContext } from '../../../../providers/CarbonEnrollmentProvider'
import { FertilizerItem } from './Fertilizer.types'
import { InfoNotification } from '../../../SuccessNotification/SuccessNotification.styles'
import { FertilizersInventoryRow } from './FertilizersInventoryRow'

export const FertilizersInventoryListing = () => {
  const { activeCompany } = useContext(CarbonEnrollmentContext)
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [fertilizerData, setFertilizerData] = useState<any>([])
  const { t } = useTranslation()

  useEffect(() => {
    API.get(`/fertilizerInventory/${activeCompany?.id}`, { headers: { Authorization: `Bearer ${ls.get('loginCredentials')}` } }).then(({ data }: {data: FertilizerItem[]}) => {
      setFertilizerData(data)
      setIsLoading(false)
    })
  }, [activeCompany])

  if (isLoading) {
    return <Loading />
  }

  return (
    <DataTableContainer>
      <ResponsiveTableWrap>
        <Table sx={{ minWidth: 650, borderCollapse: 'collapse' }} aria-label={t('fertilizerInvoiceManagement.title')}>
          <TableHead>
            <TableRow>
              <TableCell>{t('general.year')}</TableCell>
              <TableCell align="center">{t('fertilizerInvoiceManagement.fertilizerType')}</TableCell>
              <TableCell align="center">{t('fertilizerInvoiceManagement.percentage')}</TableCell>
              <TableCell align="center">{t('fertilizerInvoiceManagement.quantity')}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {fertilizerData.length > 0 ? (
              fertilizerData.map((row: FertilizerItem) => (
                <FertilizersInventoryRow
                  rowData={row}
                  key={`row-key-${row.id}`}
                />
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={4} sx={{ padding: 0, border: 'none !important' }}>
                  <InfoNotification marginBottom="0px">{t('fertilizerInvoiceManagement.noFertilizerInvoiceData')}</InfoNotification>
                </TableCell>
              </TableRow>

            )}
          </TableBody>
        </Table>
      </ResponsiveTableWrap>
    </DataTableContainer>
  )
}
